/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ProjectResponseStatus = typeof ProjectResponseStatus[keyof typeof ProjectResponseStatus];


export const ProjectResponseStatus = {
  active: 'active',
  archived: 'archived',
} as const;
